import { useSelector } from 'react-redux';
import { ELEMENT_NAMES } from './_constants';
import Spinner from '../../components/UI/Spinner/Spinner';
const WithLoadingHandler = props => {
	let { ancillary, isLoading, showChildren = true, ...restProps } = props;
	// priority assigned to `props.isLoading` then `state.ancillary.loading` then `state.apps.loading`
	// abstract equality check on `props.isLoading` if property destructures as `undefined`
	const loading = useSelector(state =>
		isLoading != null
			? isLoading
			: ancillary
			? state.ancillary.loading
			: state.apps.loading
	);
	let spinner = loading ? (
		<Spinner data-test={ELEMENT_NAMES.SPINNER} />
	) : null;
	return (
		<div data-test={ELEMENT_NAMES.ROOT} {...restProps}>
			{showChildren ? restProps.children : null}
			{spinner}
		</div>
	);
};

export default WithLoadingHandler;
